import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import Skeleton from 'react-loading-skeleton'
import RequirementProfile from '../../../components/discover/aivy-pdf-reports/components/requirementProfile'
import { Heading } from '../../../components/ui/Heading'
import { useLanguageContext, useUserContext } from '../../../context'
import { useDiscover } from '../hooks/useDiscover'
import { useRequirementProfileDownload } from '../hooks/useRequirementProfileDownload'
import { getProfileOptions } from '../utils'
import EnableFlexSwitch from './EnableFlexSwitch'
import InfoCardPair from './InfoCardPair'
import PrintButton from './PrintButton'
import ProfileDropdown from './ProfileDropdown'

export default function RequirementProfileSection({
  career,
  talent,
  requirementProfile,
  className = '',
  isLoading
}) {
  const { t } = useTranslation()
  const {
    selectedResult,
    setSelectedResult,
    isFlexibleMatchingEnabled,
    setIsFlexibleMatchingEnabled
  } = useDiscover()
  const { language } = useLanguageContext()
  const { activeSpace } = useUserContext()
  const hasCompletedOnboarding = activeSpace?.hasCompletedOnboarding

  const canShowInfoCards = Boolean(career && talent)

  const { downloadRequirementProfile } = useRequirementProfileDownload({
    careerId: career?.id,
    language,
    hasCompletedOnboarding
  })

  return (
    <div
      id='requirement-profile-component'
      className={clsx('relative w-full rounded-lg bg-white py-6', className)}
    >
      {isLoading && (
        <div className='mb-4 flex justify-center'>
          <span className='text-sm text-darkBlack'>
            {t('discover.talent_report.isLoading')}
          </span>
        </div>
      )}
      <div className='border-b border-lightGrey px-6 pb-6'>
        <div className='flex flex-row items-start justify-between'>
          <div>
            <Heading level={6} className={'text-primaryBlue'}>
              {isLoading ? (
                <Skeleton />
              ) : (
                t('discover.talent_match_section.title')
              )}
            </Heading>
            <ProfileDropdown
              className='mt-1'
              selectedProfile={selectedResult}
              profileOptions={getProfileOptions(t)}
              onProfileChange={setSelectedResult}
              isLoading={isLoading}
            />
          </div>
          <EnableFlexSwitch
            enabled={isFlexibleMatchingEnabled}
            setEnabled={setIsFlexibleMatchingEnabled}
            isLoading={isLoading}
          />
        </div>
        {canShowInfoCards && <InfoCardPair career={career} talent={talent} />}
      </div>
      <div className='relative mt-8'>
        <RequirementProfile
          data={requirementProfile}
          withoutAttachments
          hasCompletedOnboarding={hasCompletedOnboarding}
          isLoading={isLoading}
        />
        <div className='mt-6 px-6'>
          <PrintButton
            onClick={downloadRequirementProfile}
            text={t('discover.talent_match_section.print_button')}
            disabled={!hasCompletedOnboarding}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  )
}
